import jwtFetch from "./jwt";

const RECEIVE_CURRENT_USER = "session/RECEIVE_CURRENT_USER";
const RECEIVE_SESSION_ERRORS = "session/RECEIVE_SESSION_ERRORS";
const CLEAR_SESSION_ERRORS = "session/CLEAR_SESSION_ERRORS";
const UPDATE_USER_PROFILE = "session/UPDATE_USER_PROFILE";
export const RECEIVE_USER_LOGOUT = "session/RECEIVE_USER_LOGOUT";

// export const updateUserProfile = (user) => ({
//   type: UPDATE_USER_PROFILE
//   user,
// });

// Dispatch receiveCurrentUser when a user logs in.
const receiveCurrentUser = (currentUser) => ({
  type: RECEIVE_CURRENT_USER,
  currentUser,
});

// Dispatch receiveErrors to show authentication errors on the frontend.
const receiveErrors = (errors) => ({
  type: RECEIVE_SESSION_ERRORS,
  errors,
});

// Dispatch logoutUser to clear the session user when a user logs out.
const logoutUser = () => ({
  type: RECEIVE_USER_LOGOUT,
});

export const getCurrentUser = () => async (dispatch) => {
  const res = await jwtFetch("/api/users/current");
  const user = await res.json();
  return dispatch(receiveCurrentUser(user));
};

// Dispatch clearSessionErrors to clear any session errors.
export const clearSessionErrors = () => ({
  type: CLEAR_SESSION_ERRORS,
});

export const signup = (user) => startSession(user, "api/users/register");
export const login = (user) => startSession(user, "api/users/login");

const startSession = (userInfo, route) => async (dispatch) => {
  try {
    const res = await jwtFetch(route, {
      method: "POST",
      body: JSON.stringify(userInfo),
    });
    const { user, token } = await res.json();
    localStorage.setItem("jwtToken", token);
    return dispatch(receiveCurrentUser(user));
  } catch (err) {
    const res = await err.json();
    if (res.statusCode === 400) {
      return dispatch(receiveErrors(res.errors));
    }
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("jwtToken");
  dispatch(logoutUser());
};

export const updateUserProfile = (userInfo) => async (dispatch) => {
  try {
    const { image, id } = userInfo;

    // const body = { image };
    const formData = new FormData();

    formData.append("image", image);

    const res = await jwtFetch(`/api/users/${id}`, {
      method: "PATCH",
      body: formData,
    });

    const updatedUser = await res.json();

    return dispatch(receiveCurrentUser(updatedUser));
  } catch (err) {
    const res = await err.json();
    if (res.statusCode === 400) {
      return dispatch(receiveErrors(res.errors));
    }
  }
};

// append form data isn't working. going to try passing image direct above
// export const updateUserProfile = (userInfo) => async (dispatch) => {
//   try {
//     const { image, id } = userInfo;
//     const formData = new FormData();

//     // formData.append("username", username);
//     // formData.append("password", password);
//     // formData.append("email", email);

//     formData.append("image", image);

//     const res = await jwtFetch(`/api/users/${id}`, {
//       method: "PATCH",
//       body: formData,
//     });
//     const updatedUser = await res.json();
//     return dispatch(receiveCurrentUser(updatedUser));
//   } catch (err) {

//     const res = await err.json();

//     if (res.statusCode === 400) {
//       return dispatch(receiveErrors(res.errors));
//     }
//   }
// };

const initialState = {
  user: undefined,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_CURRENT_USER:
      return { user: action.currentUser };
    case UPDATE_USER_PROFILE:
      return { user: action.updatedUser };
    case RECEIVE_USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const nullErrors = null;

export const sessionErrorsReducer = (state = nullErrors, action) => {
  switch (action.type) {
    case RECEIVE_SESSION_ERRORS:
      return action.errors;
    case RECEIVE_CURRENT_USER:
    case CLEAR_SESSION_ERRORS:
      return nullErrors;
    default:
      return state;
  }
};

export default sessionReducer;
